import {TrackInfo} from "../../model/track-info";
import {TrackUtil} from "../../track-util";
import {TrackActionResult} from "../../model/track-action-result";

export class BirthCountryAction{

    // Literal que será validada no campo nome
    static readonly countryName = 'BRASIL';

    //página onde ocorre a ação
    static readonly birthCountryPageId = 'birth-country';
    
    // Proxima pagina caso Brasil
    static readonly birthStatePageId = 'birth-state';
    
    // Paginas que serão removidas caso <> Brasil
    static readonly removePages = ['birth-city', BirthCountryAction.birthStatePageId];

    // Proxima pagica caso <> Brasil 
    static readonly genderPageId = 'gender';
    
    
    public static execute(data: any, track: TrackInfo[], originalTracks: TrackInfo[]){
        track = TrackUtil.rebuildTracks(this.birthCountryPageId, track, originalTracks);
        if (data.personalData.countryOfBirthName && this.countryName &&
            data.personalData.countryOfBirthName.toUpperCase() === this.countryName.toUpperCase()) {

            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.birthStatePageId)],
                track);
        } else {

            const newtrack = track.filter(i => !this.removePages.includes(i.pageId))
            
            // const newtrack = track
            //     .filter(r => r.pageId != this.birthStatePageId
            //         && r.pageId != this.birthCityPageId)
            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.genderPageId)],
                newtrack);
        }
    }
}